package org.hs_soft.runmynesto.pages.home.sub_page.user.mvi

import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import org.hs_soft.runmynesto.data.api_datasource.RequestManager
import org.hs_soft.runmynesto.domain.errorMessage
import org.hs_soft.runmynesto.domain.requestHandler
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.general_error_model.GeneralError
import org.hs_soft.runmynesto.domain.model.home.template.GridItemsFilterEnum
import org.hs_soft.runmynesto.domain.model.home.user.UserCancellationReasonEnum
import org.hs_soft.runmynesto.domain.model.home.user.UserInfoHeaderEnum
import org.hs_soft.runmynesto.domain.model.home.user.single_user.GetUser
import org.hs_soft.runmynesto.domain.model.home.user.tabs.user_checkout.user_checkout_model.Children
import org.hs_soft.runmynesto.domain.model.home.user.users_info.UserModel
import org.hs_soft.runmynesto.domain.usecase.home.GetSavedCheckOutUseCase
import org.hs_soft.runmynesto.domain.usecase.user.AddUserUseCase
import org.hs_soft.runmynesto.domain.usecase.user.SingleUserUseCase
import org.hs_soft.runmynesto.domain.usecase.user.UpdateUserDataUseCase
import org.hs_soft.runmynesto.domain.usecase.user.UsersDataUseCase
import org.hs_soft.runmynesto.domain.usecase.user.tab_checkout.UpdateUserCheckoutUseCase
import org.hs_soft.runmynesto.domain.usecase.user.tab_general.UpdateUserImageUseCase
import org.hs_soft.runmynesto.domain.usecase.user.tab_right.UpdateUserPermissionUseCase
import org.hs_soft.runmynesto.domain.usecase.user.tab_right.UpdateUserWaiterUseCase
import org.hs_soft.runmynesto.domain.util.ApiUtils
import org.hs_soft.runmynesto.domain.util.helper.BaseViewModel
import org.hs_soft.runmynesto.pages.home.sub_page.closing_reports.mvi.ClosingReportsEvent

class UserViewModel(
    private val requestManager: RequestManager,
    private val updateUserCheckoutUseCase: UpdateUserCheckoutUseCase,
    private val updateUserPermissionUseCase: UpdateUserPermissionUseCase,
    private val addUserUseCase: AddUserUseCase,
    private val singleUserUseCase: SingleUserUseCase,
    private val usersDataUseCase: UsersDataUseCase,
    private val updateUserWaiterUseCase: UpdateUserWaiterUseCase,
    private val updateUserImageUseCase: UpdateUserImageUseCase,
    private val updateUserDataUseCase: UpdateUserDataUseCase,
    private val getSavedCheckOutUseCase: GetSavedCheckOutUseCase,
): BaseViewModel()  {

    private val _state = MutableStateFlow(UserState())
    val state: StateFlow<UserState> = _state


    private var tempUsers:List<UserModel> = listOf()
    private var tempCheckoutList:List<Children> ?= listOf()

    override fun clear() {
        super.clear()
        requestManager.cancelAll()
    }


    fun onEvent(event: UserEvent) {
        when (event) {

            is UserEvent.DismissErrorDialog->{
                _state.value=_state.value.copy(
                    errorInfo = null,
                )
            }

            is UserEvent.GetUsersData->getUsersData( )

            is UserEvent.OnUserClick ->onUserClick(
                id=event.id,
                switchTheSecondPage=event.callBack,
            )

            is UserEvent.SetFilterUserItemsComponentStatus->{
                _state.value=_state.value.copy(
                    showUserItemsFilterComponent = event.status
                )
            }
            is UserEvent.SubmitUserFilterItems->{
                submitUserFilterItems(type=state.value.selectedUserFilterItemsType)
            }
            is UserEvent.SelectFilterType->{
                _state.value=_state.value.copy(selectedUserFilterItemsType = event.type)
            }


            is UserEvent.UpdateCheckout->{
                updateCheckout(
                    dataValue = event.dataValue,
                    id=state.value.selectedUser?.id?:"",
                )
            }
            is UserEvent.GetCheckoutData->{
                getCheckoutData( )
            }
            is UserEvent.UpdateUserInfo ->updateUserInfo(
                dataTitle = event.dataTitle,
                dataValue = event.dataValue,
                id = state.value.selectedUser?.id?:"",
            )
            is UserEvent.UpdateUserPermissionInfo ->updateUserPermissionInfo(
                dataTitle = event.dataTitle,
                dataValue = event.dataValue,
                id = state.value.selectedUser?.id?:"",
            )
            is UserEvent.UpdateUserWaiterKey ->updateUserWaiterKey(
                dataValue = event.dataValue,
                id = state.value.selectedUser?.id?:"",
            )
            is UserEvent.OnSelectImageClick->updateUserImage(
                url = event.url,
                id=state.value.selectedUser?.id?:"",
            )
            is UserEvent.RefreshUserList ->{
                getUsersData(   )
            }



            is UserEvent.OnSearchCheckoutItems->{
                searchCheckoutItems(value=event.value)
            }

            //Add Record
            is UserEvent.OnAddRecordIconClick->onAddRecordIconClick()
            is UserEvent.OnCancelAddNewUserDialogClick->dismissAddRecordDialog()

            is UserEvent.OnChangeRecordName->onChangeRecordName(event.value)
            is UserEvent.OnChangeRecordNumber->onChangeRecordNumber(event.value)

            is UserEvent.OnSubmitAddNewUserDialogClick->{
                onSubmitAddNewUserDialogClick(
                    windowMode = event.windowMode,
                    name=state.value.newRecordName,
                    code =state.value.newRecordNumber,
                )
            }

            //Cancellation
            is UserEvent.OnCancellationItemClick ->{
                onCancellationItemClick(
                    cancelReason = event.cancelReason,
                    userId = state.value.selectedUser?.id?:"",
                )
            }


            //Header Events
            is UserEvent.OnTabClick->onTabClick(event.tab)

            //Searching User
            is UserEvent.OnSearchUserInputChange ->onSearchUserInputChange(event.value)
            is UserEvent.OnNumberSortClick ->onNumberSortClick()
            is UserEvent.OnTitleSortClick ->onTitleSortClick()


            //Other
            is UserEvent.OnUserInfoDetailPassEyeClick ->onUserInfoDetailPassEyeClick()
            is UserEvent.OnChangePageClick->changePage()


        }
    }

    private fun submitUserFilterItems(type: GridItemsFilterEnum) {
        when(type){
            GridItemsFilterEnum.ALL_ITEMS->{
                _state.value=_state.value.copy(
                    usersInfo = tempUsers,
                    showUserItemsFilterComponent=false,
                )
            }
            GridItemsFilterEnum.ACTIVE_ITEMS->{
                _state.value=_state.value.copy(
                    usersInfo = tempUsers.filter {
                        it.isActive==true
                    },
                    showUserItemsFilterComponent=false,
                )
            }
            GridItemsFilterEnum.INACTIVE_ITEMS->{
                _state.value=_state.value.copy(
                    usersInfo = tempUsers.filter {
                        it.isActive==false
                    },
                    showUserItemsFilterComponent=false,
                )
            }
        }
    }

    private fun updateUserPermissionInfo(
        dataTitle: String,
        dataValue: dynamic,
        id: String,
    ) {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(loadingProgress = isLoading)
                },
                callRequest = {
                    updateUserPermissionUseCase(
                        dataTitle = dataTitle,
                        dataValue = dataValue,
                        userId = id
                    )
                },
                onSuccess = { result ->
                    val model = result.data.cashAssist.updateUser
                    _state.value = _state.value.copy(
                        selectedUser = state.value.selectedUser
                            ?.copy(
                                cancelationPermissions = model.cancelationPermissions,
                                isDayFinStatements = model.isDayFinStatements,
                                isTimeTracking = model.isTimeTracking,
                                isViewSales = model.isViewSales,
                                isManager = model.isManager,
                                isAdmin = model.isAdmin,
                                isFinStatements = model.isFinStatements
                            )
                    )
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun searchCheckoutItems(value: String) {
        if (value.isEmpty()) {
            _state.value = _state.value.copy(
                cashList = tempCheckoutList,
                checkOutExpandAll = false
            )
            return
        }

        val searchTerm = value.lowercase()
        val searchedList = tempCheckoutList?.mapNotNull { model ->
            val filteredChildrenX = model.children?.mapNotNull { childX ->
                val filteredChildrenXX = childX.children?.mapNotNull { childXX ->
                    val filteredChildrenXXX = childXX.children.filter { childXXX ->
                        childXXX.name?.lowercase()?.contains(searchTerm) == true
                    }

                    if (childXX.name?.lowercase()?.contains(searchTerm) == true || filteredChildrenXXX.isNotEmpty()) {
                        childXX.copy(children = filteredChildrenXXX)
                    } else null
                }

                if (childX.name?.lowercase()?.contains(searchTerm) == true || filteredChildrenXX?.isNotEmpty() == true) {
                    childX.copy(children = filteredChildrenXX)
                } else null
            }

            if (model.name?.lowercase()?.contains(searchTerm) == true || filteredChildrenX?.isNotEmpty() == true) {
                model.copy(children = filteredChildrenX)
            } else null
        }

        _state.value = _state.value.copy(
            cashList = searchedList,
            checkOutExpandAll = true
        )
    }

    private fun updateUserWaiterKey(
        dataValue: String,
        id: String,
    ) {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(loadingProgress = isLoading)
                },
                callRequest = {
                    updateUserWaiterUseCase(
                        dataValue = dataValue,
                        userId = id
                    )
                },
                onSuccess = { result ->
                    _state.value = _state.value.copy(
                        selectedUser = state.value.selectedUser?.copy(waiterKey = dataValue)
                    )
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun onTabClick(tab: UserInfoHeaderEnum) {
        _state.value=_state.value.copy(selectedTab = tab)
    }

    private fun onSubmitAddNewUserDialogClick(
        name: String,
        code: String,
        windowMode: WindowSizeModeEnum,
    ) {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(addNewUserLoading = isLoading)
                },
                callRequest = {
                    addUserUseCase(
                        name = name,
                        code = code
                    )
                },
                onSuccess = { result ->
                    _state.value = _state.value.copy(
                        showAddRecordDialog = false,
                        addRecordErrorMessage = "",
                        newRecordName = "",
                        newRecordNumber = "",
                        selectedUser = GetUser(
                            id = result.data?.cashAssist?.createMutation?.id?:"",
                            name = result.data?.cashAssist?.createMutation?.name,
                            password = "",
                            isActive = true,
                        ),
                        imgUrl = null,
                        firstPageActive = windowMode != WindowSizeModeEnum.PHONE
                    )
                    getUsersData()
                },
                onError = { result ->
                    _state.value = _state.value.copy(
                        addRecordErrorMessage = errorMessage(result.errors)
                    )
                    showRequestError(result.errors)
                },
                onException = { e ->
                    _state.value = _state.value.copy(
                        addRecordErrorMessage = e.message.toString()
                    )
                    showException(e)
                }
            )
        }
    }

    private fun onChangeRecordNumber(value: String) {
        _state.value=_state.value.copy(
            newRecordNumber = value
        )
        checkAddRecordSubmitClickable()
    }

    private fun onChangeRecordName(value: String) {
        _state.value=_state.value.copy(
            newRecordName = value
        )
        checkAddRecordSubmitClickable()
    }

    private fun checkAddRecordSubmitClickable(){
        if (
            state.value.newRecordNumber.isNotEmpty()
            && state.value.newRecordName.isNotEmpty()
        ){
            _state.value=_state.value.copy(
                isAddNewRecordSubmitClickable = true
            )
        }else _state.value=_state.value.copy(
            isAddNewRecordSubmitClickable = false
        )
    }

    private fun dismissAddRecordDialog() {
        _state.value=_state.value.copy(
            showAddRecordDialog = false,
            addRecordErrorMessage = "",
            addNewUserLoading = false,
        )
        addUserUseCase.cancel()
    }

    private fun onAddRecordIconClick() {
        _state.value=_state.value.copy(
            showAddRecordDialog = true
        )
    }

    private fun updateUserInfo(
        dataTitle: String,
        dataValue: String,
        id: String,
    ) {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(loadingProgress = isLoading)
                },
                callRequest = {
                    updateUserDataUseCase(
                        dataValue = dataValue,
                        dataTitle = dataTitle,
                        userId = id
                    )
                },
                onSuccess = { result ->
                    if (dataTitle == ApiUtils.Field.isActive) {
                        tempUsers = tempUsers.map { user ->
                            if (user.id == id) {
                                user.copy(isActive = dataValue as Boolean)
                            } else {
                                user
                            }
                        }
                        submitUserFilterItems(type = state.value.selectedUserFilterItemsType)
                    }

                    if (dataTitle == ApiUtils.Field.name) {
                        getUsersData()
                    }

                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun updateCheckout(
        dataValue: MutableSet<String>,
        id: String,
    ) {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(loadingProgress = isLoading)
                },
                callRequest = {
                    updateUserCheckoutUseCase(
                        dataValue = dataValue,
                        userId = id
                    )
                },
                onSuccess = { result ->
                    _state.value = _state.value.copy(
                        selectedUser = state.value.selectedUser?.copy(
                            cashRegisterId = result.data.cashAssist.updateUser.cashRegisterId
                        )
                    )
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun updateUserImage(
        url: String,
        id: String,
    ) {
        _state.value = _state.value.copy(
            imgUrl = url
        )

        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(loadingProgress = isLoading)
                },
                callRequest = {
                    updateUserImageUseCase(
                        image = url,
                        id = id,
                        type = ApiUtils.Type.user
                    )
                },
                onSuccess = { result -> },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun getCheckoutData() {
        launch {
            if (state.value.cashList == null) {
                requestHandler(
                    callRequest = {
                        getSavedCheckOutUseCase()
                    },
                    onSuccess = { result ->
                        _state.value = _state.value.copy(
                            cashList = result?.data?.cashAssist?.children
                        )
                        tempCheckoutList = state.value.cashList
                    },
                    onError = { result ->
                        showRequestError(result?.errors)
                    },
                    onException = { e ->
                        showException(e)
                    }
                )
            }
        }
    }

    private fun onUserClick(
        id: String,
        switchTheSecondPage: () -> Unit = {},
    ) {
        if (id != state.value.selectedUser?.id) {
            launch {
                requestHandler(
                    loadingState = { isLoading ->
                        _state.value = _state.value.copy(loadingProgress = isLoading)
                    },
                    callRequest = {
                        singleUserUseCase(id = id)
                    },
                    onSuccess = { result ->
                        val selectedUser = result.data.cashAssist.getUser
                        val chosenReason = UserCancellationReasonEnum.entries.find {
                            selectedUser.cancelationPermissions == it.id
                        }

                        _state.value = _state.value.copy(
                            selectedUser = selectedUser,
                            imgUrl = selectedUser.img?.url,
                            cancellationReason = chosenReason ?: UserCancellationReasonEnum.NO_AUTHORIZATION,
                        )

                        switchTheSecondPage()
                    },
                    onError = { result ->
                        showRequestError(result.errors)
                    },
                    onException = { e ->
                        showException(e)
                    }
                )
            }
        } else {
            switchTheSecondPage()
        }
    }

    private fun getUsersData() {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(loadingProgress = isLoading)
                },
                callRequest = {
                    usersDataUseCase()
                },
                onSuccess = { result ->
                    val users = result.data?.cashAssist?.listUsers?.items ?: listOf()
                    _state.value = _state.value.copy(
                        usersInfo = users.filter {
                            it.isActive ?: false
                        },
                        showNumberSortIcon = false
                    )
                    tempUsers = users

                    if (state.value.usersInfo.isNotEmpty() && state.value.selectedUser == null) {
                        onUserClick(
                            id = state.value.usersInfo[0].id,
                        )
                    }
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun changePage() {
        _state.value=_state.value.copy(
            firstPageActive = !_state.value.firstPageActive
        )
    }

    private fun onNumberSortClick() {
        val newData: List<UserModel> = if (_state.value.isNumberSortedAsc) {
            _state.value.usersInfo.sortedByDescending { it.code }
        } else {
            _state.value.usersInfo.sortedBy { it.code }.toList()
        }
        _state.value = _state.value.copy(
            usersInfo = newData,
            isNumberSortedAsc = !_state.value.isNumberSortedAsc,
            showNumberSortIcon = true,
            showTitleSortIcon = false
        )
    }

    private fun onTitleSortClick() {
        val newData: List<UserModel>
        if (_state.value.isNameSortedAsc) {
            newData = _state.value.usersInfo.sortedByDescending { it.name?.lowercase() }
        } else {
            newData = _state.value.usersInfo.sortedBy { it.name?.lowercase() }.toList()
        }
        _state.value = _state.value.copy(
            usersInfo = newData,
            isNameSortedAsc = !_state.value.isNameSortedAsc,
            showTitleSortIcon = true,
            showNumberSortIcon = false
        )
    }

    private fun onSearchUserInputChange(value: String) {
        submitUserFilterItems(type = state.value.selectedUserFilterItemsType)

        val newData = _state.value.usersInfo.filter { model ->
            (
                    model.name?.contains(value, ignoreCase = true) == true ||
                            model.code?.contains(value, ignoreCase = true) == true
                    )
        }
        _state.value = _state.value.copy(
            usersInfo = newData
        )
    }

    private fun onUserInfoDetailPassEyeClick() {
        _state.value = _state.value.copy(
            userInfoDetailPasswordVisibility = !_state.value.userInfoDetailPasswordVisibility
        )
    }

    private fun onCancellationItemClick(
        cancelReason: dynamic,
        userId: String,
    ) {
        val chosenReason = UserCancellationReasonEnum.entries.find {
            cancelReason == it.name
        }
        _state.value = _state.value.copy(
            cancellationReason = chosenReason ?: UserCancellationReasonEnum.NO_AUTHORIZATION
        )

        updateUserPermissionInfo(
            id = userId,
            dataTitle = ApiUtils.Field.cancellationPermissions,
            dataValue = chosenReason?.id ?: "",
        )
    }

    private fun showRequestError(result:List<GeneralError?>?) {
        _state.value = _state.value.copy(
            errorInfo = errorMessage(result)
        )
    }
    private fun showException(e: Exception) {
        if (!e.toString().contains(ApiUtils.Status.ERR_401)){
            _state.value = _state.value.copy(
                errorInfo = e.message.toString()
            )
        }
    }

}